/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldValueType } from './FieldValueType';
import {
    FieldValueTypeFromJSON,
    FieldValueTypeFromJSONTyped,
    FieldValueTypeToJSON,
    FieldValueTypeToJSONTyped,
} from './FieldValueType';

/**
 * 
 * @export
 * @interface FieldChangeResponse
 */
export interface FieldChangeResponse {
    /**
     * 
     * @type {string}
     * @memberof FieldChangeResponse
     */
    fieldKey: string;
    /**
     * 
     * @type {FieldValueType}
     * @memberof FieldChangeResponse
     */
    valueType: FieldValueType;
    /**
     * 
     * @type {string}
     * @memberof FieldChangeResponse
     */
    oldValue: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldChangeResponse
     */
    newValue: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldChangeResponse
     */
    oldDisplayValue: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldChangeResponse
     */
    newDisplayValue: string | null;
}



/**
 * Check if a given object implements the FieldChangeResponse interface.
 */
export function instanceOfFieldChangeResponse(value: object): value is FieldChangeResponse {
    if (!('fieldKey' in value) || value['fieldKey'] === undefined) return false;
    if (!('valueType' in value) || value['valueType'] === undefined) return false;
    if (!('oldValue' in value) || value['oldValue'] === undefined) return false;
    if (!('newValue' in value) || value['newValue'] === undefined) return false;
    if (!('oldDisplayValue' in value) || value['oldDisplayValue'] === undefined) return false;
    if (!('newDisplayValue' in value) || value['newDisplayValue'] === undefined) return false;
    return true;
}

export function FieldChangeResponseFromJSON(json: any): FieldChangeResponse {
    return FieldChangeResponseFromJSONTyped(json, false);
}

export function FieldChangeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldChangeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fieldKey': json['fieldKey'],
        'valueType': FieldValueTypeFromJSON(json['valueType']),
        'oldValue': json['oldValue'],
        'newValue': json['newValue'],
        'oldDisplayValue': json['oldDisplayValue'],
        'newDisplayValue': json['newDisplayValue'],
    };
}

export function FieldChangeResponseToJSON(json: any): FieldChangeResponse {
    return FieldChangeResponseToJSONTyped(json, false);
}

export function FieldChangeResponseToJSONTyped(value?: FieldChangeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fieldKey': value['fieldKey'],
        'valueType': FieldValueTypeToJSON(value['valueType']),
        'oldValue': value['oldValue'],
        'newValue': value['newValue'],
        'oldDisplayValue': value['oldDisplayValue'],
        'newDisplayValue': value['newDisplayValue'],
    };
}

